__turbopack_context__.v({
  "captions": "saltMeter-module-scss-module__C6Bhza__captions",
  "empty": "saltMeter-module-scss-module__C6Bhza__empty",
  "fill": "saltMeter-module-scss-module__C6Bhza__fill",
  "fill-in": "saltMeter-module-scss-module__C6Bhza__fill-in",
  "meter": "saltMeter-module-scss-module__C6Bhza__meter",
  "segment": "saltMeter-module-scss-module__C6Bhza__segment",
  "segments": "saltMeter-module-scss-module__C6Bhza__segments",
});
